import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { getMonthlyStatusReport } from "~/graphql/queries";

export const EMPTY_MONTHLY_STATUS: APITypes.MonthlyStatusReport = {
  __typename: "MonthlyStatusReport",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  createdAt: "",
  updatedAt: "",
  month: 0,
  year: 0,
  numOccupied: 0,
  numVacant: 0,
  numRenovation: 0,
  expectedRent: 0,
  expectedStayRevenue: 0,
  aggregateIncome: {
    __typename: "IncomeStatement",
    rentRevenue: 0,
    stayRevenue: 0,
    feeRevenue: 0,
    otherRevenue: 0,
    totalRevenue: 0,
    repairExpenses: 0,
    lostRentExpenses: 0,
    renovationExpenses: 0,
    totalExpenses: 0,
    net: 0,
    ownerID: "",
    ownerType: APITypes.OwnerType.User,
  },
  numUnits: 0,
  numBuildings: 0,
  numProperties: 0,
  numServiceRequests: 0,
  numAmenities: 0,
  numAmenityReservations: 0,
  _version: 0,
  _lastChangedAt: 0,
};

export const getEmptyMonthlyStatusReport = ({
  ownerID,
  ownerType,
  month,
  year,
  entityID,
  entityType,
}: {
  ownerID: string;
  ownerType: APITypes.OwnerType;
  month: number;
  year: number;
  entityID: string;
  entityType: APITypes.EntityType;
}): APITypes.MonthlyStatusReport => {
  return {
    __typename: "MonthlyStatusReport",
    id: "",
    ownerID,
    ownerType,
    month: month,
    year: year,
    entityID,
    entityType,
    createdAt: "",
    updatedAt: "",
    numOccupied: 0,
    numVacant: 0,
    numRenovation: 0,
    expectedRent: 0,
    expectedStayRevenue: 0,
    aggregateIncome: {
      __typename: "IncomeStatement",
      rentRevenue: 0,
      stayRevenue: 0,
      feeRevenue: 0,
      otherRevenue: 0,
      totalRevenue: 0,
      repairExpenses: 0,
      lostRentExpenses: 0,
      renovationExpenses: 0,
      totalExpenses: 0,
      net: 0,
      ownerID,
      ownerType,
    },
    numUnits: 0,
    numBuildings: 0,
    numProperties: 0,
    numServiceRequests: 0,
    numAmenities: 0,
    numAmenityReservations: 0,
    _version: 0,
    _lastChangedAt: 0,
  };
};

export const getMonthlyStatusDetails = async (recordId: string) => {
  try {
    const response = (await API.graphql({
      query: getMonthlyStatusReport,
      variables: {
        id: recordId,
      },
    })) as { data?: APITypes.GetMonthlyStatusReportQuery };

    if (!response.data?.getMonthlyStatusReport) {
      throw new Error("No monthly status report found");
    }

    return {
      success: true,
      data: response.data?.getMonthlyStatusReport || EMPTY_MONTHLY_STATUS,
    };
  } catch (error) {
    console.error(
      "failed to get monthly status report",
      recordId,
      "error",
      error
    );
    return {
      success: false,
      data: EMPTY_MONTHLY_STATUS,
      error,
    };
  }
};
